import { useLang } from "@/App";
import { all, pick } from "@/data/images";
import Hero from "@/components/Hero";
import { Reveal, Pretitulo } from "@/components/Reveal";

export default function Terminos() {
  const { t } = useLang();
  const p = t.terminos;
  return (
    <div data-testid="pagina-terminos">
      <Hero pre={p.hero.pre} titulo={p.hero.titulo} fotos={[pick(p.hero.foto[0], 0) || all(p.hero.foto[0])[0]]} testid="hero-terminos" />
      <section className="py-20 md:py-28" data-testid="tc-intro">
        <div className="mx-auto max-w-2xl px-6 text-center md:px-10">
          <Reveal>
            <Pretitulo>{p.pre}</Pretitulo>
            <h2 className="mt-4 font-serif text-3xl font-light tracking-tight text-ink md:text-4xl">{p.titulo}</h2>
            <p className="mt-7 text-[15px] leading-relaxed text-ink-soft">{p.cuerpo}</p>
          </Reveal>
        </div>
      </section>
      <section className="pb-20 md:pb-28" data-testid="tc-listado">
        <div className="mx-auto max-w-3xl px-6 md:px-10">
          {p.items.map((it, i) => (
            <Reveal key={it.t} delay={Math.min(i * 0.03, 0.3)} className="flex items-baseline gap-6 border-b border-lineas py-8 first:border-t" testid={`tc-item-${i + 1}`}>
              <span className="font-serif text-2xl text-terra">{i + 1}.</span>
              <div>
                <h3 className="font-serif text-2xl font-light text-ink">{it.t}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft">{it.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}